import React from 'react';

import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { css, styled } from 'styled-components';

import GenericContainer from 'components/GenericContainer';
import IconButton from 'components/IconButton/IconButton';
import { AlertSize } from 'components/Layout/Header/components/AlertBanner';

const MainNavWrapper = styled('div')<{ $scrollUp: boolean; $alertOpen: boolean }>(
  ({ theme, $scrollUp, $alertOpen }) => css`
    font-family: ${(props) => props.theme.fonts.default};
    position: sticky;
    top: ${$alertOpen
      ? `calc(${AlertSize.lg} + ${$scrollUp ? '1.75rem' : '2.5rem'})`
      : $scrollUp
        ? '1.75rem'
        : '2.5rem'};
    width: 100%;
    background-color: ${theme.colors.white};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3.75rem;
    transform: ${$scrollUp ? 'translateY(-50%)' : 'none'};
    transition: all 0.5s;
    box-shadow: ${theme.colors.boxShadowGray} 0 0.0625rem 0.125rem 0;
    z-index: 11;

    @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
      display: none;
    }
  `
);

const MainNavContainer = styled('div')(
  () => css`
    display: flex;
    gap: 2.5rem;
    align-items: center;
  `
);

const StyledIconButton = styled(IconButton)(
  ({ theme }) => css`
    color: ${theme.colors.primaryRed};
    font-size: 1.15rem;
  `
);

export interface MainNavProps {
  children: React.ReactNode;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  scrollDirection?: string;
  alertOpen: boolean;
}

const MainNav: React.FC<MainNavProps> = ({ children, setShow, scrollDirection, alertOpen }) => (
  <MainNavWrapper $scrollUp={scrollDirection === 'up'} $alertOpen={alertOpen}>
    <GenericContainer $styles={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <MainNavContainer>{children}</MainNavContainer>
      <StyledIconButton
        data-testid='searchButton'
        aria-label='Search'
        onClick={() => setShow(true)}
        icon={faMagnifyingGlass}
      />
    </GenericContainer>
  </MainNavWrapper>
);

export default MainNav;
